import { RefObject, useContext } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { useTranslation } from 'react-i18next'

import { ThemeSwitchContext } from 'src/providers/theme-provider'

interface IRecaptchaProps {
  captchaRef: RefObject<ReCAPTCHA>
}

export const Recaptcha = ({ captchaRef }: IRecaptchaProps) => {
  const { i18n } = useTranslation()
  const { isDark } = useContext(ThemeSwitchContext)

  return (
    <ReCAPTCHA
      badge="bottomleft"
      lang={i18n.language}
      ref={captchaRef}
      sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY!}
      size="invisible"
      theme={isDark ? 'dark' : 'light'}
    />
  )
}
